import {v4} from 'uuid';

const clientUUID = (() => {
  const id = window.localStorage.getItem('client-uuid');
  if (id === null) {
    const newId = v4();
    window.localStorage.setItem('client-uuid', newId);

    return newId;
  }

  return id;
})();

export default clientUUID;
